module.exports = __webpack_public_path__ + "img/water.64345c8a.png";